import { Aggregator } from './aggregator';

export enum AccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
  LOAN = 'LOAN',
  CREDIT_CARD = 'CREDIT_CARD',
  UNKNOWN = 'UNKNOWN',
}

export enum AccountUsage {
  PROFESSIONAL = 'PROFESSIONAL',
  PERSONAL = 'PERSONAL',
  UNKNOWN = 'UNKNOWN',
}

export interface Owner {
  name: string;
}

export enum OwnershipType {
  HOLDER = 'HOLDER',
  CO_HOLDER = 'CO_HOLDER',
  ATTORNEY = 'ATTORNEY',
  OTHER = 'OTHER',
}

export interface Bank {
  id?: string;
  logoUrl?: string;
  name?: string;
  country?: string;
}

export enum SavingsType {
  SHORT_TERM = 'SHORT_TERM',
  LONG_TERM = 'LONG_TERM',
  UNKNOWN = 'UNKNOWN',
}

export interface Savings {
  type?: SavingsType;
  openedAt?: string;
  maximumAmount?: number;
  interestRate?: number;
}

export enum LoanType {
  REVOLVING = 'REVOLVING',
  PERSONAL = 'PERSONAL',
  MORTGAGE = 'MORTGAGE',
  OTHER = 'OTHER',
}

export interface Loan {
  type?: LoanType;
  amount?: number;
  startDate?: string;
  endDate?: string;
  duration?: number;
  insuranceLabel?: string;
  payment?: number;
  remainingCapital?: number;
  interestRate?: number;
}

export interface AccountDetails {
  savings?: Savings;
  loan?: Loan;
}

export interface DailyBalance {
  date: string;
  balance: number;
}

export interface Account {
  id: string;
  balance: number;
  balanceDate: string;
  currency: string;
  type: AccountType;
  usage: AccountUsage;
  owners?: Owner[];
  ownership?: OwnershipType;
  iban?: string;
  bic?: string;
  name?: string;
  bank?: Bank;
  country?: string;
  createdAt?: string;
  updatedAt?: string;
  coming?: number;
  details?: AccountDetails;
  aggregator?: Aggregator;
  dailyBalances: DailyBalance[];
  relatedAccountIds?: string[];
  isComputed?: boolean;
  originalIndex?: number;
}

export interface AccountWithRealBalance extends Account {
  realBalance: number;
  realBalanceDate: string;
}

export interface AccountWithIndex extends AccountWithRealBalance {
  index: number;
}

export interface CheckingAccount extends AccountWithIndex {
  type: Exclude<AccountType, typeof AccountType.LOAN | typeof AccountType.CREDIT_CARD | typeof AccountType.UNKNOWN>;
}

export interface AccountItem extends AccountWithIndex {
  numberOfTransactions: number;
  color?: string;
}
